import * as Api from '@ViewModels';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { getDisplayName } from '../../../../models/NameUtils';
import { Pill } from '../../../components-v2/Pill';
import { THEME } from '../../../components-v2/Theme/theme';

interface IProps {
	item: Api.IActionItem;
	max?: number;
}

export function getReferencedContacts(item: Api.IActionItem): Api.IContact[] {
	return (item.referencedEntities?.contacts ?? []).map(reference => reference.entity).filter(contact => !!contact?.id);
}

export const ContactChips: React.FC<IProps> = ({ item, max = 2 }) => {
	const history = useHistory();
	const contacts = getReferencedContacts(item);
	if (contacts.length === 0) {
		return null;
	}
	const visible = contacts.slice(0, max);
	const overflow = contacts.length - visible.length;
	return (
		<span className={css(styleSheet.container)} onClick={event => event.stopPropagation()}>
			{visible.map(contact => (
				<Pill
					key={contact.id}
					variant='tag'
					color='blue'
					size='small'
					label={getDisplayName(contact)}
					value={contact.id}
					onClick={id => history.push(`/people/${id}`)}
				/>
			))}
			{overflow > 0 ? <span className={css(styleSheet.overflow)}>+{overflow}</span> : null}
		</span>
	);
};

const styleSheet = StyleSheet.create({
	container: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		flexWrap: 'wrap',
	},
	overflow: {
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
	},
});
